import React, { useState, useEffect } from 'react'
import axios from 'axios'
import { Select } from 'antd'
import MyIcon from '../general/icon'

const MyCollegeSelect = ({ 
  id,
  required = false,
  label = '',
  value = '',
  onChange,
  errorMsg,
  disabled = false,
  notFoundContent = '暂无数据',
  styles
}) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [collegeList, setCollegeList] = useState([])

  useEffect(() => {
    axios.post('/p/info/college/list/get', { merchant_oid: merchantOid })
      .then(function (response) {
        if (response.errcode === 0) {
          setCollegeList(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [merchantOid])

  let items = [
    ...collegeList.map((item) => (
      {
        value: item.oid,
        label: item.name
      }
    ))
  ]

  if (collegeList.length === 0) {
    value = ''
    items = []
  }

  const noData = (
    <div className='select-noData'>
      <span style={{ fontSize: '50px', color: '#aaa' }}><MyIcon name='kong' /></span>
      <p>{notFoundContent}</p>
    </div>
  )

  return (
    <div className='select-container'>
      <label>
        {label}
        {required && <span style={{ color: '#ae2a19' }}> *</span>}
      </label>

      <Select
        disabled={disabled}
        placeholder="选择一个所属院系"
        value={value}
        onChange={(value) => onChange(prevValues => ({ ...prevValues, [id]: value }))}
        notFoundContent={noData}
        options={items}
        style={{ width: '360px', height: '40px', marginBottom: '5px', ...styles }}
      />

      {errorMsg && (
        <div className="form-errormsg">
          <span><MyIcon name='jinggao' /></span> 
          <p>{errorMsg}</p>
        </div>
      )}
    </div>  
  )
}

export default MyCollegeSelect
